import ouiBase from '@goldwasserexchange/oui';
import { useAccountOrderFieldTransfomApiByOpbFordId } from '../api';
import { AccountsOrder } from '../../type';

const transformFunction = (id: AccountsOrder['P_OPB.ID']): 'BUY' | 'SELL' | undefined => {
  if (id == null) {
    return undefined;
  }
  if (id === 1) {
    return 'BUY';
  }
  if (id === 6) {
    return 'SELL';
  }
  return undefined;
};

export const useAccountOrderPOpbDirection = () => {
  const opbFordDId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useAccountOrderFieldTransfomApiByOpbFordId({
    opbFordDId,
    field: 'P_OPB.ID',
    transformFunction,
  });
  return response;
};
